import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PromoCode from './PromoCode.lazy';

import { RootState } from 'components/play/redux/store';
import { setDiscountValue } from 'components/play/redux/storeSlice';

export default function PurchasePromoCode() {
    const dispatch = useDispatch();
    const { ticketPrice } = useSelector((state: RootState) => state.playStore);

    return (
        <div id="promo-code">
            <PromoCode
                useplace="purchase"
                setDiscountValue={(value) => dispatch(setDiscountValue(value))}
                ticketPrice={ticketPrice}
            />
        </div>
    );
}
